/*
|--------------------------------------------------------------------------
| Utilities: Promowiz
|--------------------------------------------------------------------------
*/
__gh__webApp.utilities.promowiz = {
	"init":function(){
		var currentDomain = __gh__coreData.siteData.baseURL;
		$("#header-main-promo").load(currentDomain+"/section/?template=ajaxPromoWiz7");
	}
};